// extracted by mini-css-extract-plugin
export default {"MuiStepLabel-label":"stepper_MuiStepLabel-label__BT9Jd"};